import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  avatarConfirm: {
    width: '52px',
    height: '52px',
    border: '2px solid #BBE9F9',
  },
}));
